import { gql } from '@apollo/client';
import type { SourceEvent } from '../../../types';

export const EVENT_QUERY = gql`
  query event($eventId: ID!) {
    event(eventId: $eventId)
      @rest(
        path: "/galleries/api/events/registration/{args.eventId}?locale=en-US&includeHasResults=true"
        type: "SourceEvent"
        endpoint: "bff"
      ) {
      id
      name
      eventDate
      eventUrl
      country
      city
      subdivision
      locale @type(name: "EventLocales") {
        availableLocales
        event
        preferred
      }
      association {
        logo
        title
      }
      branding {
        logo
        backgroundColor
        primaryColor
        primaryFontColor
        secondaryColor
        secondaryFontColor
        tertiaryColor
        tertiaryFontColor
      }
      hasResults
      status
    }
  }
`;

export type EventQueryVariables = {
  eventId: string;
};

export type EventQueryResponseData = {
  event?: SourceEvent;
};
